// Fichier : App/PageTransition.js (Version refactorisée)
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

import barba from "@barba/core";
import Animations from "./Animations.js";

export default class PageTransition {
  static app;
  static scrollPositions = {};
  static currentAnimations;

  static init(app) {
    // On garde une seule référence à l'instance de l'application
    this.app = app;

    barba.init({
      sync: false,
      transitions: [this.defaultTransition()], // La transition est maintenant une méthode dédiée
    });
  }

  static defaultTransition() {
    return {
      name: "default-transition",

      // On utilise des fonctions "handler" pour chaque hook
      once: (data) => this.handleOnce(data),
      leave: (data) => this.handleLeave(data),
      enter: (data) => this.handleEnter(data),
      after: (data) => this.handleAfter(data),
    };
  }

  static async handleOnce(data) {
    await document.fonts.ready;
    this.app.initNavigation(data.next.namespace)
    this.app.initPageInteractions(data.next)
    this.app.prepareInitialAnimations(data.next.container);
  }

  static async handleLeave(data) {
    // console.log("Barba.js - leave");
    // this.app.scroll.lenis.stop();
    // this.killOldAnimations();

    await this.playTransitionIn();
  }

  static async handleEnter(data) {
    // console.log("Barba.js - enter");
    const oldContainer = document.querySelector('[data-barba="container"]');
    if (oldContainer) oldContainer.replaceWith(data.next.container);

    this.app.initNavigation(data.next.namespace)
    this.app.initPageInteractions(data.next)
    this.handleScroll(data.next.namespace);
    this.initAnimations(data.next.container);
    ScrollTrigger.refresh();

    await this.playTransitionOut();
    this.app.scroll.lenis.start();
    
    if(this.app.navigation){this.app.navigation.createTimeline()}
  }

  static handleAfter(data) {
    // console.log("Barba.js - after");
    if (this.currentAnimations) this.currentAnimations.start();
  }

  // --- Méthodes utilitaires pour gérer les animations et les transitions ---
  static initAnimations(container) {
    this.killOldAnimations();
    this.currentAnimations = new Animations(container);
  }

  static killOldAnimations() {
    if (this.currentAnimations) {
      this.currentAnimations.kill();
    }
  }

  static playContentAnimations() {
    if (this.currentAnimations) {
      this.currentAnimations.playAnimations();
    }
  }

  static saveScrollPosition(path) {
    this.scrollPositions[path] = this.app.scroll.lenis.scroll;
  }

  static restoreScrollPosition(data) {
    const targetPosition = this.scrollPositions[data.next.url.path] || 0;
    this.app.scroll.lenis.scrollTo(targetPosition, { immediate: true });
  }

  static async playTransitionIn() {
    await this.app.experience.transition.playIn();
  }

  static async playTransitionOut() {
    await this.app.experience.transition.playOut();
  }

  static handleScroll(namespace) {
    if (namespace === "project") {
      this.app.scroll.lenis.scrollTo(0, { immediate: true });
    }
  }
}
